import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import FileSaver from "file-saver";
import { eventBus } from "../../utils/eventBus";
import { getOrCreateTabId } from "../../utils/tabId";
const API_BASE_URL = process.env.REACT_APP_BASE_URL
// Helper: normalize axios error messages for user-friendly feedback
const extractErrorMessage = (error, fallback = "Something went wrong") => {
  const axiosMsg =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback;
  return typeof axiosMsg === "string" ? axiosMsg : fallback;
};

export const fetchOrders = createAsyncThunk(
  "order/fetchOrders",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/order/fetch`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      //console.log("response", response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const fetchOrderById = createAsyncThunk(
  "order/fetchOrderById",
  async (data, {dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/order/fetch/${data.id}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          params: data, // Send data as query parameters
        }
      );
      //console.log("response", response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const insertOrder = createAsyncThunk(
  "order/insertOrder",
  async (data, {dispatch, rejectWithValue }) => {
    //console.log(data, "data");
    const formdata = new FormData();
    formdata.append("name", data?.name);
    if (Array.isArray(data?.assignedEditors)) {
      data.assignedEditors.forEach((item, index) => {
        formdata.append("assignedEditors", item);
      });
    }
    if (Array.isArray(data?.zip)) {
      data.zip.forEach((item, index) => {
        formdata.append(`zip`, item);
      });
    } else {
      formdata.append("zip", data?.zip);
    }
    if (data?.thumbnail) {
      formdata.append("thumbnail", data.thumbnail[0]);
    }

    const onUploadProgress = (progressEvent) => {
      const percentage = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      dispatch(insertOrder.updateProgress(percentage)); // Dispatch progress update to Redux store
    };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/order/insert`,
        formdata,

        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          onUploadProgress
        }
      );
      

      Swal.fire({
        icon: "success",
        title: "Order Added",
        text: "The order has been added successfully!",
        timer: 3000,
        showConfirmButton: false,
      });

      return response.data;
    } catch (error) {
      console.error("Error inserting order:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Failed to add order.",
        timer: 3000,
        showConfirmButton: false,
      });

      return rejectWithValue(
        error?.response?.data || { message: "Unknown error occurred" }
      );
    }
  }
);
export const compareFace = createAsyncThunk(
  "order/compareFace",
  async (data, {dispatch, rejectWithValue }) => {
    const formData = new FormData();
    formData.append("file",data?.file);
    formData.append("path", data?.folderName);
    // Always use the same tab_id as the WebSocket
    const tabId = await getOrCreateTabId();
    formData.append("tab_id", tabId); // <-- must match backend and WebSocket
    if(data?.imageUrl)
    {

      formData.append("imageUrl", data?.imageUrl);
    }


      Swal.fire({
        title: "Matching Photos",
        text: "Scanning faces, please wait...",
        icon: "info",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
    
    try {
      const response = await axios.post(
        `${API_BASE_URL}/photos/FaceCompare`,
        formData
      );
      
      console.log(response,"response")

      // Swal.fire({
      //   icon: "success",
      //   title: "Order Added",
      //   text: "The order has been added successfully!",
      //   timer: 3000,
      //   showConfirmButton: false,
      // });
console.log(response,"response")
      return response?.data;
    } catch (error) {
      // Normalize error into a human-friendly string to avoid showing [object Object]
      const rawDetail = error?.response?.data?.error?.detail;
      const rawMessage = error?.response?.data?.message;
      let friendlyMessage = "Face not found. Please try another selfie or better lighting.";

      if (typeof rawDetail === "string" && rawDetail.trim()) {
        friendlyMessage = rawDetail;
      } else if (typeof rawMessage === "string" && rawMessage.trim()) {
        friendlyMessage = rawMessage;
      } else if (typeof rawDetail === "object" && rawDetail !== null) {
        friendlyMessage = rawDetail.message || rawDetail.error || friendlyMessage;
      }

      return rejectWithValue(friendlyMessage);
    }
  }
);


insertOrder.updateProgress = (progress) => ({
  type: 'order/updateProgress',
  payload: progress,
});
export const editOrder = createAsyncThunk(
  "order/editOrder",
  async (data, { rejectWithValue }) => {
    try {
      const formdata = new FormData();
      formdata.append("name", data?.name);
      if (Array.isArray(data?.assignedEditors)) {
        data.assignedEditors.forEach((item, index) => {
          formdata.append("assignedEditors", item);
        });
      }
      if (Array.isArray(data?.zip)) {
        data.zip.forEach((item, index) => {
          formdata.append(`zip`, item);
        });
      } else {
        formdata.append("zip", data?.zip);
      }
      if (data?.thumbnail) {
        formdata.append("thumbnail", data.thumbnail[0]);
      }
      const response = await axios.put(
        `${API_BASE_URL}/order/edit/${data.id}`,
        formdata,
        {
          headers: {
            // "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Order Updated",
        text: "The order has been updated successfully!",
        timer: 3000,
      });

      return response.data;
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Failed to update order.",
        timer: 3000,
      });
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteOrder = createAsyncThunk(
  "order/deleteOrder",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/order/delete/${id}`,
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      );

  

      return id;
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Failed to delete order.",
        timer: 3000,
      });
      return rejectWithValue(error.response.data);
    }
  }
);
let cancelDownloadSource = null;
export const loginOrder = createAsyncThunk(
  "order/loginOrder",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/order/login`, data);
      //console.log("response", response);
      return response.data;
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Failed to log in order.",
        timer: 3000,
      });
      return rejectWithValue(error.response.data);
    }
  }
);

export const deletePhotos = createAsyncThunk(
  "order/deletePhotos",
  async (mediaIds, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/photos/delete`,
        {
          mediaIds: mediaIds,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      //console.log("response", response);
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Photos have been deleted successfully.",
        timer: 3000,
      });
      return mediaIds;
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Failed to log in editor.",
        timer: 3000,
      });
      return rejectWithValue(error.response.data);
    }
  }
);
export const deleteVideo = createAsyncThunk(
  "order/deleteVideo",
  async (mediaIds, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/video/delete`,
        {
          mediaIds: mediaIds,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      //console.log("response", response);
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Photos have been deleted successfully.",
        timer: 3000,
      });
      return mediaIds;
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Failed to log in editor.",
        timer: 3000,
      });
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchVideo = createAsyncThunk(
  "order/fetchVideo",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/video/fetch/${data?.orderId}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          params: data, // Send data as query parameters
        }
      );
      console.log("response", response);
      return response.data;
    } catch (error) {
      console.log(error,"fetchVideofetchVideo")
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const cancelDownloadRequest = () => {
  if (cancelDownloadSource) {
    cancelDownloadSource.cancel("Download cancelled by user");
    cancelDownloadSource = null;
  }
};



export const fetchPhotos = createAsyncThunk(
  "order/fetchPhotos",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/photos/fetch/${data?.orderId}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          params: data, // Send data as query parameters
        }
      );
      //console.log("response", response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const fetchLabelPhotos = createAsyncThunk(
  "order/fetchLabelPhotos",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/photos/fetch/label/${data?.orderId}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          params: data, // Send data as query parameters
        }
      );
      //console.log("---------------------rrr---------", response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GenerateLink = createAsyncThunk(
  "order/GenerateLink",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/order/generatelink/${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },

        }
      );
      //console.log("response", response.data);
      return response?.data?.order;
    } catch (error) {
      //console.log(error)
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const SelectPhoto = createAsyncThunk(
  "order/SelectPhoto",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/selectphoto/select`, data,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },

        }
      );
      console.log("response", response?.data);
      return {
        photo: response?.data?.photo,
        selectedPhotosCount: response?.data?.selectedPhotosCount,
        labelSelectedCount: response?.data?.labelSelectedCount
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const disSelectPhoto = createAsyncThunk(
  "order/disSelectPhoto",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/selectphoto/disSelect`, data,
     
      );
      console.log("response", response?.data);
      return {
        photo: response?.data?.photo,
        selectedPhotosCount: response?.data?.selectedPhotosCount,
        labelSelectedCount: response?.data?.labelSelectedCount
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const orderdownload = createAsyncThunk(
  "order/orderdownload",
  async (orderdata, { rejectWithValue }) => {
    const { data, type, name, MacAddressget, tabId } = orderdata;

    // Create cancel token
    cancelDownloadSource = axios.CancelToken.source();

    try {
      const response = await axios.get(`${API_BASE_URL}/order/download/folder`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
        params: { type, folder: data, name, MacAddressget, tabId },
        cancelToken: cancelDownloadSource.token,
      
      });

      console.log(response.data?.imageUrls,"response")
      // const blob = new Blob([response.data], { type: "application/zip" });
      // FileSaver.saveAs(blob, `${name}.zip`);

      return response.data?.imageUrls;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Download cancelled");
        return rejectWithValue("Download cancelled");
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// export const detectPhotodownload = createAsyncThunk(
//   "order/detectPhotodownload",
//   async (data, { rejectWithValue, dispatch }) => {
//     // Create cancel token for the entire download process
//     cancelDownloadSource = axios.CancelToken.source();
// console.log(data,"data")

//     try {
//       console.log('Starting photo download process with data:', JSON.stringify(data, null, 2));

//       // Validate input data
//       if (!data || !data.images || !Array.isArray(data.images) || data.images.length === 0) {
//         return rejectWithValue({ error: 'Images array is required and cannot be empty' });
//       }

//       if (!data.name) {
//         return rejectWithValue({ error: 'Name is required for the files' });
//       }

//       const totalImages = data.images.length;
//       let completedDownloads = 0;
//       let failedDownloads = 0;
//       const downloadResults = [];

//       // Progress tracking function
//       const updateProgress = (progress, message, status = 'downloading') => {
//         console.log(`Progress: ${progress}% - ${message} - Status: ${status}`);
//         // Optional: dispatch progress action if you have one in your store
//         // dispatch(updateDownloadProgress({ progress, message, status }));
//       };

//       updateProgress(0, 'Initializing download process...', 'started');

//       const useZipDownload = totalImages > 10; 

//       if (useZipDownload) {
//         try {
//           updateProgress(10, 'Preparing ZIP download...', 'processing');

//           const response = await axios.post(
//          `${API_BASE_URL}/order/download/detectPhoto`,
//             data,
//             {
//               headers: {
//                 Authorization: `Bearer ${Cookies.get("token")}`,
//                 'Content-Type': 'application/json',
//               },
//               responseType: "blob",
//               cancelToken: cancelDownloadSource.token,
//               timeout: 300000, // 5 minutes timeout for large ZIP files
//               onDownloadProgress: (progressEvent) => {
//                 if (progressEvent.lengthComputable) {
//                   const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                   updateProgress(10 + (percent * 0.9), `Downloading ZIP... ${percent}%`, 'downloading');
//                 }
//               },
//             }
//           );
//           // Validate ZIP response
//           if (!response.data || response.data.size === 0) {
//             throw new Error('Empty ZIP file received from server');
//           }

//           const blob = new Blob([response.data], { type: "application/zip" });
//           FileSaver.saveAs(blob, `${data.name}.zip`);

//           updateProgress(100, 'ZIP download completed successfully!', 'completed');
//           return { 
//             success: true, 
//             method: 'zip',
//             totalFiles: totalImages,
//             fileName: `${data.name}.zip`
//           };

//         } catch (zipError) {
//           if (axios.isCancel(zipError)) {
//             console.log("ZIP download cancelled");
//             return rejectWithValue({ error: "Download cancelled", cancelled: true });
//           }
          
//           console.warn('ZIP download failed, falling back to individual downloads:', zipError.message);
//           updateProgress(0, 'ZIP failed, switching to individual downloads...', 'fallback');
//         }
//       }

//       // Individual file downloads
//       updateProgress(5, 'Starting individual file downloads...', 'processing');

//       // Limit concurrent downloads to prevent overwhelming
//       const CONCURRENT_LIMIT = 3;
      
//       for (let i = 0; i < data.images.length; i += CONCURRENT_LIMIT) {
//         // Check if download was cancelled
//         if (cancelDownloadSource.token.reason) {
//           throw new axios.Cancel('Download cancelled');
//         }

//         const batch = data.images.slice(i, i + CONCURRENT_LIMIT);
        
//         const batchPromises = batch.map(async (image, batchIndex) => {
//           const globalIndex = i + batchIndex;
          
//           try {
//             // Validate individual image object
//             if (!image || !image.mainFolderName || !image.imageName) {
//               throw new Error(`Invalid image object at index ${globalIndex}: missing required fields`);
//             }

//             console.log(`Downloading ${globalIndex + 1}/${totalImages}: ${image.imageName}`);

//             const fileResponse = await axios.post(
//               `${API_BASE_URL}/order/download/detectPhoto/single`,
//               {
//                 image,
//                 name: data.name,
//                 MacAddressget: data.MacAddressget
//               },
//               {
//                 headers: {
//                   Authorization: `Bearer ${Cookies.get("token")}`,
//                   'Content-Type': 'application/json',
//                 },
//                 responseType: 'blob',
//                 cancelToken: cancelDownloadSource.token,
//                 timeout: 60000, // 60 second timeout per file
//                 onDownloadProgress: (progressEvent) => {
//                   if (progressEvent.lengthComputable) {
//                     const filePercent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                     const overallProgress = 5 + ((completedDownloads + (filePercent / 100)) / totalImages) * 90;
//                     updateProgress(
//                       Math.round(overallProgress), 
//                       `Downloading ${image.imageName}... ${filePercent}%`,
//                       'downloading'
//                     );
//                   }
//                 },
//               }
//             );

//             // Validate file response
//             if (!fileResponse.data || fileResponse.data.size === 0) {
//               throw new Error('Empty file received from server');
//             }

//             const contentType = fileResponse.headers['content-type'] || 'application/octet-stream';
//             const blob = new Blob([fileResponse.data], { type: contentType });
            
//             // Use FileSaver for consistent download experience
//             FileSaver.saveAs(blob, image.imageName);

//             completedDownloads++;
//             const progress = 5 + (completedDownloads / totalImages) * 90;
//             updateProgress(
//               Math.round(progress), 
//               `Downloaded ${completedDownloads}/${totalImages} files`,
//               'downloading'
//             );

//             console.log(`File downloaded successfully: ${image.imageName}`);
//             return { 
//               fileName: image.imageName, 
//               success: true, 
//               index: globalIndex,
//               size: fileResponse.data.size 
//             };

//           } catch (fileError) {
//             if (axios.isCancel(fileError)) {
//               throw fileError; // Re-throw cancellation
//             }

//             failedDownloads++;
//             console.error(`Error downloading file ${image?.imageName || 'unknown'} at index ${globalIndex}:`, fileError.message);

//             return { 
//               fileName: image?.imageName || 'unknown', 
//               success: false, 
//               error: fileError.message,
//               index: globalIndex 
//             };
//           }
//         });

//         // Wait for current batch to complete
//         const batchResults = await Promise.all(batchPromises);
//         downloadResults.push(...batchResults);

//         // Small delay between batches
//         if (i + CONCURRENT_LIMIT < data.images.length) {
//           await new Promise(resolve => setTimeout(resolve, 500));
//         }
//       }

//       // Analyze final results
//       const successfulDownloads = downloadResults.filter(result => result.success);
//       const failedDownloadsList = downloadResults.filter(result => !result.success);

//       console.log(`Download Summary:
//         Total: ${totalImages}
//         Successful: ${successfulDownloads.length}
//         Failed: ${failedDownloadsList.length}`);

//       if (failedDownloadsList.length === 0) {
//         updateProgress(100, `All ${successfulDownloads.length} files downloaded successfully!`, 'completed');
//         return { 
//           success: true, 
//           method: 'individual',
//           folder: data.name, 
//           files: downloadResults,
//           summary: {
//             total: totalImages,
//             successful: successfulDownloads.length,
//             failed: 0
//           }
//         };
//       } else if (successfulDownloads.length === 0) {
//         updateProgress(0, 'All downloads failed', 'error');
//         return rejectWithValue({
//           error: 'All files failed to download',
//           details: failedDownloadsList,
//           summary: {
//             total: totalImages,
//             successful: 0,
//             failed: failedDownloadsList.length
//           }
//         });
//       } else {
//         updateProgress(95, `Partial success: ${successfulDownloads.length}/${totalImages} files downloaded`, 'warning');
//         return {
//           success: true,
//           partial: true,
//           method: 'individual',
//           folder: data.name,
//           files: downloadResults,
//           summary: {
//             total: totalImages,
//             successful: successfulDownloads.length,
//             failed: failedDownloadsList.length
//           },
//           failedFiles: failedDownloadsList
//         };
//       }

//     } catch (error) {
//       console.error('Download process error:', error);

//       if (axios.isCancel(error)) {
//         console.log("Download cancelled by user");
//         return rejectWithValue({ error: "Download cancelled", cancelled: true });
//       }

//       // Handle different error types
//       let errorMessage = 'Something went wrong during download';
      
//       if (error.code === 'ECONNABORTED') {
//         errorMessage = 'Download timeout - please try again';
//       } else if (error.response) {
//         errorMessage = error.response.data?.error || `Server error: ${error.response.status}`;
//       } else if (error.request) {
//         errorMessage = 'Network error - please check your connection';
//       } else {
//         errorMessage = error.message || errorMessage;
//       }

//       return rejectWithValue({ 
//         error: errorMessage,
//         originalError: error.message,
//         code: error.code
//       });
//     }
//   }
// );

export const detectPhotodownload = createAsyncThunk(
  'order/detectPhotodownload',
  async (data, { rejectWithValue }) => {
    cancelDownloadSource = axios.CancelToken.source();

    try {
      console.log('Starting download with data:', JSON.stringify(data, null, 2));
      console.log('API URL:', `${API_BASE_URL}/order/download/detectPhoto`);
      console.log('Token:', Cookies.get('token') ? 'Token present' : 'No token found');

      const response = await axios.post(
        `${API_BASE_URL}/order/download/detectPhoto`,
        data,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('token')}`,
            'Content-Type': 'application/json',
          },
          cancelToken: cancelDownloadSource.token,
        }
      );

      console.log('Response received:', {
        status: response.status,
        data: response.data,
      });

      // Check if response is JSON with file URLs
      if (!response.data.files || !Array.isArray(response.data.files)) {
        console.error('Unexpected response format:', response.data);
        return rejectWithValue({ error: 'Invalid response format from server' });
      }

      // Trigger downloads for each file
      const downloadPromises = response.data.files.map(async (file) => {
        try {
          const fileResponse = await axios.get(file.url, {
            responseType: 'blob',
          });

          const blob = new Blob([fileResponse.data], { type: fileResponse.headers['content-type'] });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = file.fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);

          console.log(`File downloaded: ${file.fileName}`);
          return { fileName: file.fileName, success: true };
        } catch (fileError) {
          console.error(`Error downloading file ${file.fileName}:`, fileError.message);
          return { fileName: file.fileName, success: false, error: fileError.message };
        }
      });

      const downloadResults = await Promise.all(downloadPromises);

      const failedDownloads = downloadResults.filter((result) => !result.success);
      if (failedDownloads.length > 0) {
        console.warn('Some files failed to download:', failedDownloads);
        return rejectWithValue({
          error: 'Some files failed to download',
          details: failedDownloads,
        });
      }

      console.log(`All files downloaded successfully for folder: ${data?.name}`);
      return { success: true, folder: data?.name, files: downloadResults };
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Download cancelled');
        return rejectWithValue('Download cancelled');
      }

      console.error('Download error:', error.message);
      if (error.response) {
        // Handle server error responses
        try {
          const errorData = error.response.data;
          console.error('Server error details:', errorData);
          return rejectWithValue(errorData);
        } catch {
          console.error('Could not parse error response');
          return rejectWithValue({ error: 'Server returned an invalid response' });
        }
      }

      return rejectWithValue({ error: error.message || 'Something went wrong' });
    }
  }
);

// export const detectPhotodownload = createAsyncThunk(
//   "order/detectPhotodownload",
//   async (data, { rejectWithValue }) => {
//     cancelDownloadSource = axios.CancelToken.source();
//     try {
//       if (!data || !data.images || !Array.isArray(data.images) || data.images.length === 0) {
//         return rejectWithValue({ error: 'Images array is required and cannot be empty' });
//       }

//       if (!data.name) {
//         return rejectWithValue({ error: 'Name is required for the files' });
//       }

//       const totalImages = data.images.length;
//       let completedDownloads = 0;
//       let failedDownloads = 0;
//       const downloadResults = [];

//       const updateProgress = (progress, message, status = 'downloading') => {
//         console.log(`Progress: ${progress}% - ${message} - Status: ${status}`);
//       };

//       updateProgress(0, 'Starting individual file downloads...', 'started');

//       const CONCURRENT_LIMIT = 3;
//       for (let i = 0; i < data.images.length; i += CONCURRENT_LIMIT) {
//         if (cancelDownloadSource.token.reason) throw new axios.Cancel('Download cancelled');

//         const batch = data.images.slice(i, i + CONCURRENT_LIMIT);
//         const batchPromises = batch.map(async (image, batchIndex) => {
//           const globalIndex = i + batchIndex;

//           try {
//             if (!image || !image.mainFolderName || !image.imageName) {
//               throw new Error(`Invalid image at index ${globalIndex}`);
//             }

//             const fileResponse = await axios.post(
//               `${API_BASE_URL}/order/download/detectPhoto`,
//               {
//                 image,
//                 name: data.name,
//                 MacAddressget: data.MacAddressget
//               },
//               {
//                 headers: {
//                   Authorization: `Bearer ${Cookies.get("token")}`,
//                   'Content-Type': 'application/json',
//                 },
//                 responseType: 'blob',
//                 cancelToken: cancelDownloadSource.token,
//                 timeout: 60000,
//                 onDownloadProgress: (progressEvent) => {
//                   if (progressEvent.lengthComputable) {
//                     const filePercent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                     const overallProgress = ((completedDownloads + filePercent / 100) / totalImages) * 100;
//                     updateProgress(Math.round(overallProgress), `Downloading ${image.imageName}... ${filePercent}%`);
//                   }
//                 }
//               }
//             );

//             if (!fileResponse.data || fileResponse.data.size === 0) {
//               throw new Error('Empty file received');
//             }

//             const blob = new Blob([fileResponse.data], {
//               type: fileResponse.headers['content-type'] || 'application/octet-stream'
//             });

//             FileSaver.saveAs(blob, image.imageName);

//             completedDownloads++;
//             updateProgress(
//               Math.round((completedDownloads / totalImages) * 100),
//               `Downloaded ${completedDownloads}/${totalImages} files`
//             );

//             return {
//               fileName: image.imageName,
//               success: true,
//               index: globalIndex
//             };

//           } catch (err) {
//             failedDownloads++;
//             console.error(`Failed to download ${image?.imageName || 'unknown'}:`, err.message);
//             return {
//               fileName: image?.imageName || 'unknown',
//               success: false,
//               error: err.message,
//               index: globalIndex
//             };
//           }
//         });

//         const batchResults = await Promise.all(batchPromises);
//         downloadResults.push(...batchResults);

//         if (i + CONCURRENT_LIMIT < data.images.length) {
//           await new Promise(resolve => setTimeout(resolve, 300));
//         }
//       }

//       const success = downloadResults.filter(d => d.success).length;
//       const failed = downloadResults.filter(d => !d.success).length;

//       if (failed === 0) {
//         updateProgress(100, `All ${success} files downloaded successfully!`);
//         return { success: true, method: 'individual', files: downloadResults };
//       } else if (success === 0) {
//         return rejectWithValue({ error: 'All files failed to download', files: downloadResults });
//       } else {
//         return {
//           success: true,
//           partial: true,
//           method: 'individual',
//           files: downloadResults,
//           summary: { total: totalImages, success, failed }
//         };
//       }

//     } catch (error) {
//       if (axios.isCancel(error)) {
//         return rejectWithValue({ error: 'Download cancelled', cancelled: true });
//       }

//       return rejectWithValue({
//         error: error.message || 'Download failed',
//         originalError: error
//       });
//     }
//   }
// );
export const mediaDownload = createAsyncThunk(
  "order/mediaDownload",
  async ({ url, filename }, { rejectWithValue }) => {
    console.log(`Download started for ${filename}`);

    try {
      filename = filename.split(".")[0]; // Remove file extension

      const response = await axios.post(
        `${API_BASE_URL}/order/download/file`,
        { fileUrl: url },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          responseType: "blob",
          onDownloadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            eventBus.emitProgress(filename, percentCompleted);
            console.log(`Download progress for ${filename}: ${percentCompleted}%`);
          },
        }
      );

      const contentType = response.headers["content-type"];
      const type = contentType?.split("/")[1] || "bin";

      const blob = new Blob([response.data], { type: contentType });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${filename}.${type}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      return { success: true, message: "File downloaded successfully", filename };
    } catch (error) {
      console.error(`Download error for ${filename}:`, error);
      return rejectWithValue({ error: error.response?.data || "Something went wrong", filename });
    }
  }
);
export const feedbackImage = createAsyncThunk(
  "order/feedbackImage",
  async (data, { rejectWithValue }) => {
    //console.log(data, "data")
    try {
      const response = await axios.post(
        `${API_BASE_URL}/feedbackimage/insert`, data,

      );
      //console.log("response", response);
      Swal.fire({
        icon: "success",
        title: "success!",
        text: "feedBack insert successfully.",
        timer: 3000,
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const feedbackVideo = createAsyncThunk(
  "order/feedbackVideo",
  async (data, { rejectWithValue }) => {
    //console.log(data, "data")
    try {
      const response = await axios.post(
        `${API_BASE_URL}/feedbackvideo/insert`, data,

      );
      //console.log("response", response);
      Swal.fire({
        icon: "success",
        title: "success!",
        text: "feedBack insert successfully.",
        timer: 3000,
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const MacAddressgetget = createAsyncThunk(
  "order/MacAddressget",  
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/order/deviceFingerprint`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log(response,"response")
      return response?.data?.macAddress;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Trigger ZIP creation and email delivery (used for iPhone flow)
export const generateZipCompare = createAsyncThunk(
  "order/generateZipCompare",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/zip/compare`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { message, fileCount } = response?.data || {};

      // Show success modal with improved styling
      await Swal.fire({
        icon: "success",
        title: "ZIP Generation Started",
        html: `
          <div style="text-align: center; padding: 1rem 0;">
            <p style="font-size: 1rem; color: #555; margin-bottom: 0.5rem;">
              Your ZIP file is being created in the background.
            </p>
            <p style="font-size: 0.95rem; color: #888; margin: 0.5rem 0;">
              <strong>${fileCount || 0}</strong> photo${fileCount !== 1 ? 's' : ''} will be included
            </p>
            <p style="font-size: 0.9rem; color: #666; margin-top: 1rem; font-style: italic;">
              You'll receive an email with the download link when it's ready.
            </p>
          </div>
        `,
        confirmButtonText: "Got it",
        confirmButtonColor: "#D4B0A5",
        allowOutsideClick: false,
        didOpen: () => {
          const popup = Swal.getPopup();
          popup.style.borderRadius = "16px";
          popup.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.2)";
        },
      });

      return response.data;
    } catch (error) {
      const friendly = extractErrorMessage(error, "Failed to start ZIP generation");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: friendly,
        confirmButtonColor: "#dc3545",
      });
      return rejectWithValue(friendly);
    }
  }
);